export const circles = [
  { cx: 66, cy: 67, r: 48 },
  { cx: 81.01, cy: 412.99, r: 63.01 },
  { cx: 970.01, cy: 82.01, r: 63.01 },
  { cx: 649, cy: 255, r: 63.01 },
  { cx: 151, cy: 255, r: 24 },
  { cx: 898, cy: 436.99, r: 24 },
  { cx: 702, cy: 294.01, r: 24 },
  { cx: 373, cy: 401, r: 24 },
  { cx: 349, cy: 169.03, r: 48 },
];
